document.addEventListener('DOMContentLoaded', () => {
  // Announcement dismiss
  const announce = document.querySelector('[data-announcement]');
  if (announce && localStorage.getItem('hideAnnc')) {
    announce.style.display = 'none';
  }
  document.querySelectorAll('[data-close-annc]')?.forEach(btn =>
    btn.addEventListener('click', () => {
      localStorage.setItem('hideAnnc', '1');
      announce?.remove();
    })
  );

  // Mobile menu toggle
  const burger = document.querySelector('.hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (burger && mobileMenu) {
    burger.addEventListener('click', () => {
      mobileMenu.classList.toggle('open');
      burger.setAttribute('aria-expanded', mobileMenu.classList.contains('open'));
    });
  }
});

